import Vue from "vue";
import store from "@/store";

export const createGaUserId = (
  companyId?: number,
  partnerId?: number,
  userId?: number
) => {
  const gaUserId =
    (process.env.VUE_APP_DEVELOPER || "") +
    ("00000" + companyId).slice(-5) +
    ("00000" + partnerId).slice(-5) +
    ("0000000000" + userId).slice(-10);
  return gaUserId;
};

/**
 * sendGaEvent
 *
 * @param instance Vue
 * @param option optional
 *  gaEventCategory: event_category
 *  gaEventLabel: event_label
 */
export const sendGaEvent = (
  instance?: Vue,
  option?:
    | {
        gaEventType?: string | undefined;
        gaEventCategory?: string | undefined;
        gaEventLabel?: { [key: string]: string | number | boolean } | undefined;
      }
    | undefined
) => {
  if (!instance) return;

  // set default event type
  let gaEventType = "click";

  // event_category only(by props)
  if (!option) {
    sendGaEventCategoryByProps(instance, gaEventType);
    return;
  }

  // overwrite event_type
  if (option.gaEventType) gaEventType = option.gaEventType;

  // event_category only
  if (option.gaEventCategory && !option.gaEventLabel) {
    sendGaEventWithCategory(instance, option.gaEventCategory, gaEventType);
  }

  // event_label only
  if (!option.gaEventCategory && option.gaEventLabel) {
    sendGaEventWithLabel(instance, option.gaEventLabel, gaEventType);
  }

  // both event_category and event_label
  if (option.gaEventCategory && option.gaEventLabel) {
    sendGaEventWithCategoryAndLabel(
      instance,
      option.gaEventCategory,
      option.gaEventLabel,
      gaEventType
    );
  }
};

/*
 * gaEventLabelのHashをStringに変換する
 *
 * ex)
 *   gaEventLabel: { id: 1, title: 'example1' }
 *   => '1/example1'
 */
const createEventLabel = (gaEventLabel: {
  [key: string]: string | number | boolean;
}) => {
  return Object.values(gaEventLabel).join("/");
};
const sendGaEventCategoryByProps = (instance: Vue, gaEventType: string) => {
  if (!instance.$gtag) return;

  const gaEventCategory = instance.$props.gaEventCategory;
  if (!gaEventCategory || gaEventCategory === "") return;

  sendGaEventWithCategory(instance, gaEventCategory, gaEventType);
};
const sendGaEventWithCategory = (
  instance: Vue,
  gaEventCategory: string,
  gaEventType: string
) => {
  if (!instance.$gtag) return;

  const partnerUser = store.state.domains.user.partnerUser;
  if (!partnerUser) return;

  const options = { event_category: gaEventCategory };

  const gaEvent = instance.$gtag.event;
  gaEvent(gaEventType, options);

  // production以外の場合はconsole.logを出力する(for debug)
  const debug = Object.assign({ event_type: gaEventType }, options);
  if (process.env.NODE_ENV !== "production") console.log(debug);
};
const sendGaEventWithLabel = (
  instance: Vue,
  gaEventLabel: { [key: string]: string | number | boolean },
  gaEventType: string
) => {
  if (!instance.$gtag) return;

  const partnerUser = store.state.domains.user.partnerUser;
  if (!partnerUser) return;

  const gaEventCategory = instance.$props.gaEventCategory;
  if (!gaEventCategory || gaEventCategory === "") return;

  const options = {
    event_category: gaEventCategory,
    event_label: createEventLabel(gaEventLabel)
  };

  const gaEvent = instance.$gtag.event;
  gaEvent(gaEventType, options);

  // production以外の場合はconsole.logを出力する(for debug)
  const debug = Object.assign({ event_type: gaEventType }, options);
  if (process.env.NODE_ENV !== "production") console.log(debug);
};
const sendGaEventWithCategoryAndLabel = (
  instance: Vue,
  gaEventCategory: string,
  gaEventLabel: { [key: string]: string | number | boolean },
  gaEventType: string
) => {
  if (!instance.$gtag) return;

  const partnerUser = store.state.domains.user.partnerUser;
  if (!partnerUser) return;

  if (gaEventCategory === "") return;

  if (!gaEventLabel) return;

  const options = {
    event_category: gaEventCategory,
    event_label: createEventLabel(gaEventLabel)
  };

  const gaEvent = instance.$gtag.event;
  gaEvent(gaEventType, options);

  // production以外の場合はconsole.logを出力する(for debug)
  const debug = Object.assign({ event_type: gaEventType }, options);
  if (process.env.NODE_ENV !== "production") console.log(debug);
};
